import { render, staticRenderFns } from "./ModalCommands.vue?vue&type=template&id=74946880&"
import script from "./ModalCommands.vue?vue&type=script&lang=js&"
export * from "./ModalCommands.vue?vue&type=script&lang=js&"
import style0 from "./ModalCommands.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports